(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const FX = window.RB.FX;

  function banishTyped(state, item, zoneList, type, record) {
    const src = item.source || item.iid;
    const so = src && state.objs[src];
    let n = 0;
    for (const t of zoneList.slice()) {
      if (type && !Core.isType(state, t, type)) continue;
      const b = Flow.toBanish(state, t);
      if (b && record && so) (so.flags.banishedWith = so.flags.banishedWith || []).push(b);
      n++;
    }
    return n;
  }

  Object.assign(FX.OPS, {
    move(state, item, op, p, opp) {
      const tgts = FX.refsOrSpec(state, item, op).filter(function (t) {
        if (!Flow.moveImmune(state, t, p)) return true;
        FX.opLog(state, item, "move", Core.name(state, t) + " can't be moved by enemy spells and abilities.", [], [t]);
        return false;
      });
      if (!tgts.length) return;
      if (op.dest === "base") {
        for (const t of tgts) Flow.moveUnits(state, [t], { t: "base", p: state.objs[t].controller }, { by: p });
        return;
      }
      if (op.dest === "here" && item.ctx && item.ctx.bf) {
        Flow.moveUnits(state, tgts, { t: "bf", iid: item.ctx.bf }, { by: p });
        return;
      }
      if (op.destBind || op.destRef) {
        const anchors = op.destRef ? FX.resolveRef(state, item, op.destRef) : (item.targets[op.destBind] || []);
        if (!anchors.length) return;
        const a0 = anchors[0];
        const dest = state.battlefields.indexOf(a0) >= 0 ? { t: "bf", iid: a0 } :
          (state.objs[a0] && state.objs[a0].loc) || null;
        if (dest) Flow.moveUnits(state, tgts, dest, { by: p });
        return;
      }
      if (item.vars.moveDest === undefined) {
        const locs = [];
        for (const bfIid of state.battlefields) locs.push({ t: "bf", iid: bfIid });
        for (const t of tgts) {
          const o = state.objs[t];
          const base = { t: "base", p: o.controller };
          if (!locs.some(function (l) { return Core.sameLoc(l, base); })) locs.push(base);
        }
        let cands = locs.filter(function (l) {
          return !tgts.every(function (t) { return Core.sameLoc(state.objs[t].loc, l); });
        });
        if (op.destType === "bf") cands = cands.filter(function (l) { return l.t === "bf"; });
        if (op.openBf) {
          cands = cands.filter(function (l) {
            return l.t === "bf" && !Core.unitsAt(state, l).filter(function (u) {
              return tgts.indexOf(u) < 0;
            }).length;
          });
        }
        FX.ask(state, item, "moveDest", {
          player: p, tag: "moveDest", cands: cands, min: 1, max: 1, locChoices: true,
          prompt: "Move " + tgts.map(function (t) { return Core.name(state, t); }).join(", ") + " where?",
        });
        return "wait";
      }
      Flow.moveUnits(state, tgts, item.vars.moveDest, { by: p });
      delete item.vars.moveDest;
      return;
    },

    swapLoc(state, item, op, p, opp) {
      const as = FX.resolveRef(state, item, op.a);
      const bs = FX.resolveRef(state, item, op.b);
      if (!as.length || !bs.length) return;
      const oa = state.objs[as[0]], ob = state.objs[bs[0]];
      if (!oa || oa.zone !== "board" || !ob || ob.zone !== "board") return;
      const la = oa.loc, lb = ob.loc;
      if (Core.sameLoc(la, lb)) return;
      Flow.moveUnits(state, [as[0]], lb, { by: p });
      Flow.moveUnits(state, [bs[0]], la, { by: p });
      return;
    },

    chooseDest(state, item, op, p, opp) {
      if (item.vars[op.varKey] !== undefined) return;
      const locs = op.bfOnly || op.myBfOnly ? [] : [{ t: "base", p: p }];
      for (const bfIid of state.battlefields) {
        if (op.bfOnly || state.objs[bfIid].controller === p) locs.push({ t: "bf", iid: bfIid });
      }
      if (!locs.length) return;
      if (locs.length === 1) {
        item.vars[op.varKey] = locs[0];
        return;
      }
      FX.ask(state, item, op.varKey, {
        player: p, tag: "moveDest", cands: locs, min: 1, max: 1, locChoices: true,
        prompt: op.prompt || "Choose a destination",
      });
      return "wait";
    },

    chooseEachLoc(state, item, op, p, opp) {
      const locs = [];
      for (const bfIid of state.battlefields) locs.push({ t: "bf", iid: bfIid });
      locs.push({ t: "base", p: 0 });
      locs.push({ t: "base", p: 1 });
      const key = "cel" + item.pc;
      const st = item.vars[key] = item.vars[key] || { i: 0, picked: [] };
      while (st.i < locs.length) {
        const loc = locs[st.i];
        const cands = RB.Play.candidates(state, op.spec || {}, item).filter(function (t) {
          const o = state.objs[t];
          return o && o.loc && Core.sameLoc(o.loc, loc) && st.picked.indexOf(t) < 0;
        });
        if (!cands.length) { st.i += 1; continue; }
        const pk = key + "p" + st.i;
        if (FX.ask(state, item, pk, {
          player: p, tag: "target", cands: cands,
          min: op.min === undefined ? 0 : op.min, max: op.max === undefined ? 1 : op.max,
          prompt: (op.prompt || "Choose one") + " at " +
            (loc.t === "bf" ? Core.name(state, loc.iid) : state.players[loc.p].name + "'s base"),
        })) return "wait";
        for (const t of FX.picksOf(item.vars[pk])) st.picked.push(t);
        st.i += 1;
        return "repeat";
      }
      item.targets[op.bind] = st.picked.slice();
      return;
    },

    toHand(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        if (FX.replaceEffect(state, item, t, "toHand")) continue;
        Flow.toHand(state, t);
      }
      return;
    },

    toDeck(state, item, op, p, opp) {
      for (const t of FX.refsOrSpec(state, item, op)) {
        const o = state.objs[t];
        if (!o) continue;
        const owner = o.owner;
        const from = o.loc || null;
        const fromZone = o.zone;
        const nid = Flow.leaveToZone(state, t, "deck");
        if (!nid) continue;
        if (op.bottom) state.players[owner].mainDeck.push(nid);
        else state.players[owner].mainDeck.unshift(nid);
        FX.emit(state, { type: "toDeck", iid: nid, fromIid: t, from: from, fromZone: fromZone, player: owner, bottom: !!op.bottom });
        FX.opLog(state, item, "zone", state.players[owner].name + " puts a card on the " +
          (op.bottom ? "bottom" : "top") + " of their Main Deck.");
      }
      return;
    },

    toChampionZone(state, item, op, p, opp) {
      for (const t of FX.resolveRef(state, item, op.to)) {
        const o2 = state.objs[t];
        if (!o2) continue;
        Flow.removeFromZoneLists(state, t);
        o2.zone = "champion";
        state.players[o2.owner].champion.push(t);
        FX.opLog(state, item, "zone", Core.name(state, t) + " returns to the Champion Zone.", [], [t]);
      }
      return;
    },

    recycleTargets(state, item, op, p, opp) {
      Flow.recycleCards(state, FX.refsOrSpec(state, item, op));
      return;
    },

    discard(state, item, op, p, opp) {
      if (op.to) {
        for (const t of FX.resolveRef(state, item, op.to)) {
          const o = state.objs[t];
          if (o && o.zone === "hand") Flow.discard(state, o.owner, [t]);
        }
        return;
      }
      if (op.all) {
        const whos = op.who === "each" ? [0, 1] : op.who === "opponent" ? [opp] : [p];
        for (const w of whos) {
          const hand = state.players[w].hand.slice();
          if (hand.length) Flow.discard(state, w, hand);
        }
        return;
      }
      const who = op.who === "opponent" ? opp : p;
      const hand = state.players[who].hand;
      const n = Math.min(FX.amount(state, item, op.n === undefined ? 1 : op.n), hand.length);
      if (n === 0) return;
      if (!item.vars.discardPick) {
        state.pending = {
          kind: "choose", player: who, tag: "discard",
          prompt: "Discard " + n + " card" + (n > 1 ? "s" : ""),
          cands: hand.slice(), min: n, max: n, varKey: "discardPick",
        };
        return "wait";
      }
      const discarded = Flow.discard(state, who, item.vars.discardPick);
      if (op.bind) item.targets[op.bind] = discarded;
      delete item.vars.discardPick;
    },

    token(state, item, op, p, opp) {
      const def = RB.Scripts.tokenDef(op.name);
      if (!def) return;
      const n = FX.amount(state, item, op.n === undefined ? 1 : op.n);
      const who = op.who === "opponent" ? opp : p;
      const autoReady = RB.Scripts.anySource(state, "tokensEnterReady", { controller: who });
      let total = n;
      if (def.types && def.types.indexOf("unit") >= 0 && item.vars["tdbl" + item.pc] === undefined) {
        const dblSrc = Core.ruleSources(state, "tokenDoubler", { controller: who }).find(function (s) {
          if (s.rule.requiresAtBf && !(s.obj.loc && s.obj.loc.t === "bf")) return false;
          return !(s.rule.oncePerTurn && s.obj.flags["tdbl" + state.turn.num]);
        });
        const dbl = dblSrc ? dblSrc.iid : null;
        if (dbl) {
          FX.ask(state, item, "tdbl" + item.pc, {
            player: who, tag: "may", options: ["Yes", "No"],
            prompt: Core.name(state, dbl) + ": play an additional copy of that token?",
          });
          item.vars["tdblSrc" + item.pc] = dbl;
          return "wait";
        }
      }
      if (item.vars["tdbl" + item.pc] === 0) {
        const dblSrc = item.vars["tdblSrc" + item.pc];
        const dblObj = dblSrc && state.objs[dblSrc];
        if (dblObj) {
          const dsc = RB.Scripts.forCard(state, dblSrc);
          if (dsc && dsc.tokenDoubler && dsc.tokenDoubler.oncePerTurn) dblObj.flags["tdbl" + state.turn.num] = 1;
        }
        total = n * 2;
      }
      const made = [];
      for (let i = 0; i < total; i++) {
        const o = Core.makeObj(state, {
          token: def, owner: who, controller: who, zone: "board",
          ready: !op.exhausted && (!def.types || def.types.indexOf("unit") < 0 || !!op.ready || autoReady),
        });
        made.push(o.iid);
        let loc = { t: "base", p: who };
        const hereBf = (item.ctx && item.ctx.bf) || item.hiddenBf || (item.ctx && item.ctx.hiddenBf);
        if (op.loc === "here" && hereBf) loc = { t: "bf", iid: hereBf };
        else if (op.loc === "evFrom" && item.ctx && item.ctx.ev && item.ctx.ev.from) loc = item.ctx.ev.from;
        else if (op.loc === "evTo" && item.ctx && item.ctx.ev && item.ctx.ev.to) loc = item.ctx.ev.to;
        else if (op.locVar && item.vars[op.locVar]) loc = item.vars[op.locVar];
        o.loc = loc;
        o.enteredTurn = state.turn.num;
        if (loc.t === "bf") Flow.markContested(state, loc.iid, who);
        RB.FX.emit(state, { type: "played", iid: o.iid, player: who, loc: loc, token: true });
        FX.emitPlayTriggers(state, o.iid, { controller: who, fromFacedown: false, hiddenBf: null });
      }
      if (op.bind) item.targets[op.bind] = made;
      FX.opLog(state, item, "play", state.players[who].name + " plays " + total + " " + op.name + " token" + (total > 1 ? "s" : "") + ".", made);
      state.needCleanup = true;
      return;
    },

    replaceBf(state, item, op, p, opp) {
      const ev = item.ctx && item.ctx.ev;
      const bfIid = op.bfFromEvent ? (ev && ev.bf) : FX.resolveRef(state, item, op.to)[0];
      if (!bfIid || state.battlefields.indexOf(bfIid) < 0) return;
      Flow.replaceBattlefield(state, bfIid, op.card);
      return;
    },

    restoreBf(state, item, op, p, opp) {
      const src = item.source;
      if (!src || !state.objs[src] || !state.objs[src].replacedBf) return;
      Flow.restoreBattlefield(state, src);
      return;
    },

    banish(state, item, op, p, opp) {
      const banished = [];
      for (const t of FX.refsOrSpec(state, item, op)) {
        const nid = Flow.toBanish(state, t);
        if (nid) banished.push(nid);
      }
      if (typeof op.to === "string" && op.to.charAt(0) === "$") item.targets[op.to.slice(1)] = banished;
      return;
    },

    banishSelf(state, item, op, p, opp) {
      if (item.iid) item.banishOnResolve = true;
      return;
    },

    banishDead(state, item, op, p, opp) {
      const snap = item.ctx && item.ctx.snapshot;
      const tIid = snap && snap.trashIid;
      if (!tIid || !state.objs[tIid] || state.objs[tIid].zone !== "trash") return;
      const bIid = Flow.toBanish(state, tIid);
      FX.opLog(state, item, "zone", snap.name + " is banished.", [bIid].filter(Boolean));
      const via = item.ctx.via && state.objs[item.ctx.via];
      if (via && bIid) (via.flags.banishedWith = via.flags.banishedWith || []).push(bIid);
      return;
    },

    banishZone(state, item, op, p, opp) {
      const who = op.who === "opponent" ? opp : p;
      let n = 0;
      for (const zone of op.zones || ["hand"]) n += banishTyped(state, item, state.players[who][zone], op.type, op.record);
      if (n) FX.opLog(state, item, "zone", item.label + " banishes " + n + " card" + (n > 1 ? "s" : "") + ".");
      return;
    },

    banishFromTrash(state, item, op, p, opp) {
      const n = banishTyped(state, item, state.players[p].trash, op.type, true);
      if (!n) { FX.opLog(state, item, "zone", item.label + ": nothing to banish."); return; }
      FX.opLog(state, item, "zone", item.label + " banishes " + n + " card" + (n > 1 ? "s" : "") + " from the trash.");
      return;
    },

    banishChainSpell(state, item, op, p, opp) {
      const ev = item.ctx && item.ctx.ev;
      const target = ev && ev.iid;
      if (!target) return;
      const ci = (state.chain || []).find(function (it) { return it.iid === target; });
      if (!ci) return;
      ci.banishOnResolve = true;
      if (op.withSource !== false) ci.banishWithSrc = item.source || item.iid || null;
      FX.opLog(state, item, "zone", ci.label + " will be banished with " + Core.name(state, item.source || item.iid) + ".", [ci.iid].filter(Boolean));
      return;
    },

    trashBanishedWith(state, item, op, p, opp) {
      const src = item.source && state.objs[item.source];
      if (!src) return;
      const list = (src.flags.banishedWith || []).slice();
      src.flags.banishedWith = [];
      let n = 0;
      for (const b of list) {
        const bo = state.objs[b];
        if (!bo || bo.zone !== "banish") continue;
        Flow.leaveToZone(state, b, "trash");
        n++;
      }
      if (n) FX.opLog(state, item, "zone", item.label + " puts " + n + " banished card" + (n > 1 ? "s" : "") + " into the trash.");
      return;
    },

    playBanishedWith(state, item, op, p, opp) {
      const list = (item.ctx && item.ctx.banishedWith) || [];
      for (const bIid of list) {
        const bo = state.objs[bIid];
        if (!bo || bo.zone !== "banish" || bo.owner !== p) continue;
        RB.Play.putIntoPlay(state, p, bIid, { via: item.label });
      }
      return;
    },

    playBanishedWithPick(state, item, op, p, opp) {
      const src = item.source && state.objs[item.source];
      const key = op.varKey || ("bwp" + item.pc);
      const list = ((src && src.flags.banishedWith) || []).filter(function (b) {
        const bo = state.objs[b];
        if (!bo || bo.zone !== "banish" || bo.owner !== p) return false;
        return !op.type || Core.isType(state, b, op.type);
      });
      if (!list.length) { FX.opLog(state, item, "zone", item.label + ": nothing banished with it."); return; }
      if (FX.ask(state, item, key, {
        player: p, tag: "target", cands: list, min: op.optional ? 0 : 1, max: 1,
        prompt: op.prompt || "Play which card banished with this?",
      })) return "wait";
      const picks = FX.picksOf(item.vars[key]);
      if (!picks.length) return;
      RB.Play.beginPlay(state, p, picks[0], { fromZone: "banish", viaEffect: true });
      FX.opLog(state, item, "play", state.players[p].name + " plays " + Core.name(state, picks[0]) + " (" + item.label + ").", [picks[0]]);
      return;
    },

    playCard(state, item, op, p, opp) {
      const refs = item.targets[op.to.slice(1)] || [];
      const cIid = refs[0];
      const co = cIid && state.objs[cIid];
      if (!co || co.zone !== "trash" || co.owner !== p) return;
      RB.Play.beginPlay(state, p, cIid, { fromZone: "trash", viaEffect: true });
      FX.opLog(state, item, "play", state.players[p].name + " plays " + Core.name(state, cIid) + " from the trash (" + item.label + ").", [cIid]);
      return;
    },

    playFrom(state, item, op, p, opp) {
      const refs = FX.resolveRef(state, item, op.to);
      const cIid = refs[0];
      const co = cIid && state.objs[cIid];
      if (!co) return;
      const zone = co.zone;
      if (zone === "board" || zone === "chain") return;
      const who = op.byOwner ? co.owner : p;
      let forceLoc = null;
      if (op.dest === "base") forceLoc = { t: "base", p: who };
      else if (op.locVar && item.vars[op.locVar]) forceLoc = item.vars[op.locVar];
      const playOpts = {
        fromZone: zone, viaEffect: true,
        waive: op.waive || null, energyLess: FX.amount(state, item, op.energyLess || 0),
        forceLoc: forceLoc,
      };
      if (op.anyBf) playOpts.anyBf = true;
      if (op.attachTo) {
        const host = FX.resolveRef(state, item, op.attachTo)[0];
        if (host && state.objs[host] && state.objs[host].zone === "board") playOpts.attachTo = host;
      }
      const played = RB.Play.beginPlay(state, who, cIid, playOpts);
      if (op.recycleAfterPlay && played) played.recycleOnResolve = true;
      FX.opLog(state, item, "play", state.players[who].name + " plays " + Core.name(state, cIid) +
        " from their " + zone + " (" + item.label + ").", [cIid]);
      return;
    },

    replayFromTrash(state, item, op, p, opp) {
      const key = op.varKey || ("rp" + item.pc);
      if (item.vars[key + "Done"]) return;
      const cardId = item.cardId;
      let cIid = null;
      for (let q = 0; q < 2; q++) {
        const hit = state.players[q].trash.find(function (t) {
          const c = Core.card(state, t);
          return c && c.id === cardId;
        });
        if (hit) { cIid = hit; break; }
      }
      if (!cIid) { item.vars[key + "Done"] = 1; return; }
      const who = op.whoVar !== undefined && item.vars[op.whoVar] !== undefined ? item.vars[op.whoVar] : p;
      const cost = RB.Play.costFromRes(op.cost, null);
      if (!RB.Play.poolPotentialCovers(state, who, cost, {})) { item.vars[key + "Done"] = 1; return; }
      if (FX.ask(state, item, key, {
        player: who, tag: "may", options: ["Yes", "No"],
        prompt: "Play " + Core.name(state, cIid) + " again?",
      })) return "wait";
      if (item.vars[key] !== 0) { item.vars[key + "Done"] = 1; return; }
      if (FX.askPay(state, item, key + "Paid", who, cost, item.label)) return "wait";
      item.vars[key + "Done"] = 1;
      RB.Play.beginPlay(state, who, cIid, { fromZone: "trash", viaEffect: true, waive: "all" });
      FX.opLog(state, item, "play", state.players[who].name + " plays " + Core.name(state, cIid) + " again (" + item.label + ").", [cIid]);
      return;
    },
  });
})();
